import * as t from 'io-ts';
import { pipe } from 'fp-ts/lib/function';
import { chain } from 'fp-ts/lib/Either';
import { fromNullable } from 'io-ts-types';
export const UrlFromString = new t.Type('UrlFromString', (u) => u instanceof URL, (u, c) => pipe(t.string.validate(u, c), chain((s) => {
    try {
        const url = new URL(s);
        return t.success(url);
    }
    catch (e) {
        return t.failure(u, c);
    }
})), String);
export const DateFromUnknown = new t.Type('DateFromUnknown', (input) => input instanceof Date, (input, context) => {
    if (typeof input === 'string' || typeof input === 'number' || input instanceof Date) {
        const date = new Date(input);
        if (!isNaN(date.getTime())) {
            return t.success(date);
        }
    }
    return t.failure(input, context, 'Invalid date-like input');
}, (date) => date.toISOString());
export function ArrayUpsertedEmpty(item) {
    return fromNullable(t.array(item), []);
}
//# sourceMappingURL=util.js.map